import React from "react";

interface AnimatedGridBackgroundProps {
  children: React.ReactNode;
  direction?: "up" | "down";
  duration?: number;
  cols?: number;
  rows?: number;
}

const AnimatedGridBackground: React.FC<AnimatedGridBackgroundProps> = ({
  children,
  direction = "up",
  duration = 0.1,
  cols = 16,
  rows = 6
}) => {
  const squaresCount = cols * rows;
  const squares = Array.from({ length: squaresCount });


  const squareAnimDuration = 0.3;
  const availableDelay = duration - squareAnimDuration;
  const rowDelayStep = availableDelay / (rows > 1 ? rows - 1 : 1);

  return (
    <>
      <div
        className="content__squares-grid"
        style={{
          animationDelay: `${duration + 0.1}s`,
          animationDuration: "0.4s"
        }}
      >
        {squares.map((_, index) => {
          const row = Math.floor(index / cols);
          const targetRow = direction === "up" ? (rows - 1) - row : row;



          const baseDelay = targetRow * rowDelayStep;
          const jitter = Math.random() * (rowDelayStep * 0.6);
          const delay = baseDelay + jitter;

          return (
            <div
              key={index}
              className={`anim-square direction-${direction}`}
              style={{
                animationDelay: `${delay}s`,
                animationDuration: `${squareAnimDuration}s`
              }}
            />
          );
        })}
      </div>

      <div
        className="content__final-bg"
        style={{
          animationDelay: `${duration - 0.1}s`,
          animationDuration: "0.5s"
        }}
      ></div>

      <div
        className="content__inner"
        style={{
          animationDelay: `${duration * 0.3}s`,
          animationDuration: "1s"
        }}
      >
        {children}
      </div>
    </>
  );
};

export default AnimatedGridBackground;